module.exports = __webpack_public_path__ + "img/devimg.6004ee03.png";